module.exports = __webpack_public_path__ + "static/media/close-icon.205d5587.svg";